import { render, staticRenderFns } from "./CUserSignupForm.vue?vue&type=template&id=5039c0ce&"
import script from "./CUserSignupForm.vue?vue&type=script&lang=js&"
export * from "./CUserSignupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports